


// 主页顶部人员信息显示组件

import SHUserDisplay from './src/display.vue';

/* istanbul ignore next */
SHUserDisplay.install = function(Vue) {
  Vue.component('sh-user-display', SHUserDisplay);
};

export default SHUserDisplay;



// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/user/display/index.js